import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import VueScrollactive from 'vue-scrollactive'
import marked from 'marked'
import VueAnalytics from 'vue-analytics'
import vuetify from './plugins/vuetify'
import { firestorePlugin } from 'vuefire'
import Notifications from 'vue-notification'
import UUID from 'vue-uuid'

import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';

Vue.config.productionTip = false;

Vue.use(firestorePlugin);
Vue.use(Notifications);
Vue.use(UUID);
Vue.use(require('vue-moment'));

Vue.use(VueAnalytics, {
    id: 'UA-110665184-16',
    router
});

Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'mdi'
});

Vue.use(VueScrollactive);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -100,
});

Vue.mixin({
    methods: {
        marked: function(content) {
            return marked(content);
        }
    }
});

Vue.directive('scroll', {
    inserted: function(el, binding) {
        let f = function(evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        };
        window.addEventListener('scroll', f)
    }
});

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
